
import { Options, Vue } from 'vue-class-component'

@Options({
    emits: ['close', 'open'],
    props: {
        randomData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            showResult: false,
        }
    },
    methods: {
        openClick() {
            this.$emit('open')
            this.showResult = true;
        },
        closeClick() {
            this.$emit('close')
        },
    }
})
export default class FlopModal extends Vue { }
